<template>
  <footer class="footer reveal">
    <div class="footer-inner">
      <div class="footer-brand">
        <a href="/" class="brand"><img class="brand-logo brand-logo-dark" :src="logoHorizontal" alt="House &amp; Flats"></a>
        <p>{{ $t('homeNuevo.footer.brand_p') }}</p>
        <div class="footer-social">
          <a
            v-for="s in socials"
            :key="s.name"
            class="socialcontainer"
            :class="'is-' + s.key"
            :href="s.url"
            :aria-label="s.name"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="icon" aria-hidden="true" v-html="s.icon"></span>
          </a>
        </div>
      </div>
      <div class="footer-col">
        <h5>{{ $t('homeNuevo.footer.product') }}</h5>
        <ul>
          <li><a href="/?scroll=sophi">Sophi</a></li>
          <li><a href="/?scroll=how">{{ $t('homeNuevo.home_extra.footer_how_works') }}</a></li>
          <li><router-link :to="{ name: 'formulario', query: { page: 1 } }">{{ $t('homeNuevo.hero.cta_receive') }}</router-link></li>
        </ul>
      </div>
      <div class="footer-col">
        <h5>{{ $t('homeNuevo.footer.for_companies') }}</h5>
        <ul>
          <li><a href="/?view=partners">{{ $t('homeNuevo.nav.partners') }}</a></li>
          <li><a href="/?view=universities">{{ $t('homeNuevo.nav.universidades') }}</a></li>
          <li><a href="/?view=hosts">{{ $t('homeNuevo.nav.hosts') }}</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h5>{{ $t('homeNuevo.footer.contact') }}</h5>
        <ul>
          <li><a href="https://houseandflats.com/blog/" target="_blank" rel="noopener">{{ $t('homeNuevo.footer.blog') }}</a></li>
          <li><a href="mailto:hello@houseandflats.com">hello@houseandflats.com</a></li>
          <li><a href="tel:+13055100028">+1 (305) 510-0028</a></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      <div>{{ $t('homeNuevo.footer.copyright') }}</div>
      <div class="footer-legal-links">
        <a href="/tyc">{{ $t('homeNuevo.footer.terms') }}</a>
        <span>·</span>
        <a href="/privacidad">{{ $t('homeNuevo.footer.privacy') }}</a>
        <span>·</span>
        <a href="#cookies">{{ $t('homeNuevo.footer.cookies') }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
// Logo naranja de marca. El SVG no trae margen: 94 px de ancho equivalen al
// PNG negro de 32 px de alto que había antes.
import logoHorizontal from '@/new-assets/logo-horizontal.svg'

// Íconos de marca (Font Awesome brands, viewBox propio de cada uno). El hover
// lo resuelve el CSS: el contenedor se pinta con el degradado de marca y el
// ícono pasa a blanco con `currentColor`, así no hace falta duplicar el SVG.
const ICONS = {
  instagram: '<svg fill="currentColor" viewBox="0 0 448 512" height="1.1em" width="1.1em" xmlns="http://www.w3.org/2000/svg"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>',
  facebook: '<svg fill="currentColor" viewBox="0 0 320 512" height="1.1em" width="1.1em" xmlns="http://www.w3.org/2000/svg"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/></svg>',
  linkedin: '<svg fill="currentColor" viewBox="0 0 448 512" height="1.1em" width="1.1em" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/></svg>',
  tiktok: '<svg fill="currentColor" viewBox="0 0 448 512" height="1.1em" width="1.1em" xmlns="http://www.w3.org/2000/svg"><path d="M448 209.9a210.1 210.1 0 0 1-122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"/></svg>',
};

export default {
  name: 'FooterNuevo',
  data() {
    return {
      logoHorizontal,
      socials: [
        { name: 'Instagram', key: 'instagram', url: 'https://www.instagram.com/houseandflats', icon: ICONS.instagram },
        { name: 'Facebook',  key: 'facebook',  url: 'https://www.facebook.com/HouseAndFlats', icon: ICONS.facebook },
        { name: 'LinkedIn',  key: 'linkedin',  url: 'https://www.linkedin.com/company/house-and-flats/posts/?feedView=all', icon: ICONS.linkedin },
        { name: 'TikTok',    key: 'tiktok',    url: 'https://www.tiktok.com/@houseandflats', icon: ICONS.tiktok },
      ],
    }
  }
}
</script>

<!-- lang="scss": los estilos usan anidado (@media y &:hover dentro de cada
     regla). Como CSS plano el navegador descartaba buena parte: en celular el
     footer quedaba en 4 columnas, más ancho que la pantalla (scroll horizontal). -->
<style lang="scss" scoped>
/* Footer rediseñado: fondo blanco, esquinas superiores redondeadas, tipografía
   DM Sans (la misma del formulario nuevo), e interacciones modernas (links con
   deslizamiento, redes con relleno de marca y elevación).

   La fuente se importa acá a propósito: el formulario la carga por JS solo
   cuando se monta, pero el footer está en todas las páginas, así que no puede
   depender de eso. Mismo @import que ficha.css. */
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&display=swap');

$footer-orange: #ff7a00;
$footer-magenta: #b91e7c;
$footer-ink: #1d1a17;
$footer-ink-dim: #6f6760;
$footer-line: #ece4dc;

.footer {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  /* Solo las esquinas superiores redondeadas, como se pidió. */
  border-radius: 28px 28px 0 0;
  border-top: 1px solid $footer-line;
  padding: 72px 48px 36px;
  /* Tipografía del formulario (.nf usa DM Sans). */
  font-family: 'DM Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  color: $footer-ink;
  /* Sombra suave hacia arriba: separa visualmente el footer del contenido. */
  box-shadow: 0 -18px 40px -30px rgba(29, 26, 23, .25);
}

.footer-inner {
  max-width: 1240px;
  margin: 0 auto 48px;
  display: grid;
  grid-template-columns: 1.4fr repeat(3, 1fr);
  gap: 56px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 48px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .brand {
    display: block;
    width: fit-content;
    margin-bottom: 8px;
    transition: transform .3s cubic-bezier(.22, 1, .36, 1);

    &:hover { transform: translateY(-2px); }

    @media (max-width: 768px) { margin: 0 auto 8px; }

    img { width: 94px; height: auto; display: block; }
  }

  p {
    font-size: 14px;
    color: $footer-ink-dim;
    line-height: 1.6;
    margin: 0;
    max-width: 320px;

    @media (max-width: 768px) { max-width: none; }
  }
}

/* ── Redes sociales ─────────────────────────────────────────────────── */
.footer-social {
  display: flex;
  gap: 12px;
  margin-top: 10px;

  @media (max-width: 768px) { justify-content: center; }
}

.socialcontainer {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  color: $footer-ink;
  background: #f6f1ec;
  border: 1px solid $footer-line;
  overflow: hidden;
  transition: transform .3s cubic-bezier(.34, 1.56, .64, 1),
              box-shadow .3s ease,
              color .3s ease,
              border-color .3s ease;

  /* Relleno de marca que entra desde abajo en hover. El color concreto lo
     define cada modificador .is-<red> más abajo. */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, $footer-orange 0%, $footer-magenta 100%);
    transform: translateY(100%);
    transition: transform .35s cubic-bezier(.22, 1, .36, 1);
    z-index: 0;
  }

  .icon {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform .35s cubic-bezier(.34, 1.56, .64, 1);
  }

  &:hover,
  &:focus-visible {
    color: #fff;
    border-color: transparent;
    transform: translateY(-4px);
    box-shadow: 0 12px 22px -10px rgba(29, 26, 23, .45);
    outline: none;

    &::before { transform: translateY(0); }
    .icon { transform: scale(1.12); }
  }

  /* ── Color de marca por red ──────────────────────────────────────── */
  /* Instagram: su degradado característico (naranja → magenta → violeta). */
  &.is-instagram::before {
    background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285aeb 90%);
  }
  &.is-instagram:hover { box-shadow: 0 12px 22px -10px rgba(214, 36, 159, .6); }

  /* Facebook: azul/celeste de marca. */
  &.is-facebook::before { background: linear-gradient(135deg, #1877f2 0%, #4293ff 100%); }
  &.is-facebook:hover { box-shadow: 0 12px 22px -10px rgba(24, 119, 242, .6); }

  /* LinkedIn: azul corporativo. */
  &.is-linkedin::before { background: linear-gradient(135deg, #0a66c2 0%, #378fe9 100%); }
  &.is-linkedin:hover { box-shadow: 0 12px 22px -10px rgba(10, 102, 194, .6); }

  /* TikTok: multicolor (cian + magenta sobre negro), como su logo. */
  &.is-tiktok::before { background: linear-gradient(135deg, #25f4ee 0%, #000000 50%, #fe2c55 100%); }
  &.is-tiktok:hover { box-shadow: 0 12px 22px -10px rgba(254, 44, 85, .55); }
}

/* ── Columnas de links ──────────────────────────────────────────────── */
.footer-col {
  h5 {
    font-size: 13px;
    font-weight: 600;
    color: $footer-ink;
    margin: 0 0 18px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  ul { list-style: none; padding: 0; margin: 0; }

  li {
    margin-bottom: 12px;
    &:last-child { margin-bottom: 0; }

    a {
      position: relative;
      display: inline-block;
      color: $footer-ink-dim;
      text-decoration: none;
      font-size: 14.5px;
      transition: color .25s ease, transform .25s cubic-bezier(.22, 1, .36, 1);

      /* Subrayado animado de marca. */
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -2px;
        width: 100%;
        height: 1.5px;
        background: linear-gradient(90deg, $footer-orange, $footer-magenta);
        transform: scaleX(0);
        transform-origin: left;
        transition: transform .3s cubic-bezier(.22, 1, .36, 1);
      }

      &:hover {
        color: $footer-ink;
        transform: translateX(3px);
        &::after { transform: scaleX(1); }
      }

      @media (max-width: 768px) {
        &:hover { transform: none; }
        &::after { left: 50%; transform: translateX(-50%) scaleX(0); }
        &:hover::after { transform: translateX(-50%) scaleX(1); }
      }
    }
  }
}

/* ── Barra inferior ─────────────────────────────────────────────────── */
.footer-bottom {
  max-width: 1240px;
  margin: 0 auto;
  border-top: 1px solid $footer-line;
  padding-top: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }

  > div:first-child {
    font-size: 13.5px;
    color: $footer-ink-dim;
  }
}

.footer-legal-links {
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    justify-content: center;
    flex-wrap: wrap;
  }

  a {
    color: $footer-ink-dim;
    text-decoration: none;
    font-size: 13.5px;
    transition: color 0.2s ease;
    &:hover { color: $footer-orange; }
  }

  span { color: $footer-line; }
}

@media (max-width: 768px) {
  .footer {
    padding: 48px 24px 28px;
    border-radius: 22px 22px 0 0;
  }
  .footer-inner { margin-bottom: 40px; }
}
</style>
